import React, { memo } from 'react';

import styled from 'styled-components';
import { Button } from 'atoms';
import { FormFieldset } from 'organisms/ResumeForm/FormFieldset';
import { Colors, IResumeDate, IResumeFields, Languages } from 'context';
import { IEducationValues, ResumeEducationCard } from 'organisms';

export interface IEducationBlock {
  language: Languages;
  fields: IResumeFields;
  education: IEducationValues[];
  onAddEducation: () => void;
  onInputChange: (name: string, value: string | IResumeDate) => void;
  onRemoveEducation: (id: string) => void;
}

export const EducationBlockComponent = memo(
  ({
    language,
    fields,
    education,
    onAddEducation,
    onRemoveEducation,
    onInputChange,
  }: IEducationBlock) => (
    <FormFieldset groupTitle={fields.education.fieldsetTitle}>
      <ItemWrapper>
        {!!education.length &&
          education.map((item, index) => (
            <ResumeEducationCard
              key={item.id}
              language={language}
              fields={fields}
              index={index}
              values={item}
              onRemoveEducation={onRemoveEducation}
              onInputChange={onInputChange}
            />
          ))}
      </ItemWrapper>
      <Button variant="outline" colors={{ borderColor: Colors.gray }} onClick={onAddEducation}>
        {fields.education.addEducationButton}
      </Button>
    </FormFieldset>
  ),
);

const ItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-bottom: 24px;
`;
